import { Component, OnInit } from '@angular/core';
import { IBuyUnits } from 'src/app/interface/dto';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { UnitsService } from 'src/app/services/units.service';

@Component({
  selector: 'app-buyunits',
  templateUrl: './buyunits.component.html',
  styleUrls: ['./buyunits.component.scss']
})
export class BuyunitsComponent implements OnInit {

  buyUnits: IBuyUnits = {
    units: 0,
    price: 0,
    pricePerUnit: 0
  }
  constructor(private unitService: UnitsService, private snackBar: SnackbarService,) { }

  ngOnInit(): void {
    this.unitService.getUnitsConfig().then((u: any) => {
      this.buyUnits.pricePerUnit = u.data;

    });

  }

  getPrice() {
    this.buyUnits.price = this.buyUnits.pricePerUnit * this.buyUnits.units;
  }

 async submitUnit() {
    if (this.buyUnits.units <= 0) {
      this.snackBar.warning("Units must be greater than 0");
      return;
    }
    let url = "";
    await this.unitService.buyUnits(this.buyUnits.units).then((u: any) => {
      
      url = u.data;
    });
    ;
    window.open(url, "_blank");
  }

}
